<template>
    <div 
        v-if="items.length" 
        class="container content-space-1"
    >
        <div :class="{'row justify-content-center': isContentWidth}">
            <div :class="{'col col-lg-9': isContentWidth}">
                <div
                    v-if="$validateText(slice.primary.text)"
                    class="rich-text text-center mb-4"
                    v-html="$prismic.asHtml(slice.primary.text)"
                />
                <div class="d-md-flex flex-md-wrap d-grid grid-template-columns-2 justify-content-center align-items-center gap-3 row-gap-5 gap-md-5 text-center">
                    <optional-link 
                        v-for="(item, index) in items" 
                        :key="index"
                        :href="item.url"
                        :target="item.target"
                        :type="item.type"
                    >
                        <prismic-image 
                            :img="item.image"
                            class="max-width-100"
                            w="150"
                        />
                    </optional-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import OptionalLink from '@/components/OptionalLink.vue';
export default {
    components: {
        OptionalLink
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        isContentWidth() {
            return this.slice.primary.slice_width !== 'container';
        },
        items() {
            return this.slice.items
                .filter(item => item.image.url)
                .map(item => {
                    const link = this.$linkFieldResolver(item.link);
                    return {
                        image: item.image,
                        url: link?.url,
                        target: link?.target,
                        type: link?.type
                    };
                });
        }
    }
};
</script>